module.exports = __webpack_public_path__ + "static/engineering-fc1dbc235dcad276684c2ea1aeeb3507.png";